// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  msgId: __t.u64().primaryKey().name("msg_id"),
  sender: __t.identity(),
  senderName: __t.string().name("sender_name"),
  target: __t.identity(),
  text: __t.string(),
  nonce: __t.u32(),
  at: __t.timestamp(),
});
